import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../../supabaseClient"; // Import Supabase client
import ConfirmationPopup from "../common/ConfirmationPopup"; // Import ConfirmationPopup component
import Cookies from "js-cookie"; // Import Cookies
import SessionPopup from "../common/SessionPopup"; // Import SessionPopup component
import { removeSessionandChatHistory } from "../../chatHistory"; // Import removeSessionandChatHistory function
import { createChatSession } from "../../chatSession"; // Import createChatSession function
import useResetSession from "../common/ResetSession"; // Import useResetSession hook
import LoaderElement from "../common/Loader";
import { Button, Dropdown, ListGroup, Form, InputGroup } from "react-bootstrap"; // Import Bootstrap components

function NotificationSession({ isNotificationSessionChannel , isSidebarVisible }) {
  const [sessions, setSessions] = useState([]);
  const [userId, setuserId] = useState(null);
  const [showOptions, setShowOptions] = useState(null);
  const [sessionToRemove, setSessionToRemove] = useState(null);
  const [sessionToRename, setSessionToRename] = useState(null);
  const [isNewSession, setIsNewSession] = useState(false);
  const [Loader, setLoader] = useState(false);
  const [showFormPopup, setShowFormPopup] = useState(false);
  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // Add state for search qu\ery
  const [checkedSessions, setCheckedSessions] = useState([]);
  const [deleteAllChecked, setDeleteAllChecked] = useState(false);

  const resetSession = useResetSession(); // Initialize the useResetSession hook
  const mainSessionRef = useRef(null);
  const optionsRef = useRef(null);
  const notificationsessionScrollRef = useRef(null);
  const ulRef = useRef(null);
  const scrollPosition = useRef(0);
  const [activeSessionDelete, setActiveSessionDelete] = useState(false);

 

  useLayoutEffect(() => {
    const ul = ulRef.current;
    if (ul) scrollPosition.current = ul.scrollTop;
  });

  useEffect(() => {
    const ul = ulRef.current;
    if (ul) ul.scrollTop = scrollPosition.current;
  });
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mainSessionRef.current &&
        !mainSessionRef.current.contains(event.target) &&
        optionsRef.current &&
        !optionsRef.current.contains(event.target)
      ) {
        setShowOptions(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sessions]);
  // useEffect(() => {
  //   if (showOptions) {
  //     // const container = document.querySelector('.sessionBox')
  //     const container = ulRef.current
  //     const optionRefContainer = optionsRef.current
  //     container.scrollTo({
  //       top: container.scrollTop + optionRefContainer.scrollHeight,
  //       behavior: 'smooth'
  //     })
  //   }
  // }, [showOptions])
  useEffect(() => {
    if (showOptions && ulRef.current && optionsRef.current) {
      const container = ulRef.current;
      const popup = optionsRef.current;

      const containerRect = container.getBoundingClientRect();
      const popupRect = popup.getBoundingClientRect();

      // Check if popup is outside the visible container (bottom overflow)
      if (popupRect.bottom > containerRect.bottom) {
        const scrollOffset = popupRect.bottom - containerRect.bottom + 10; // 10px buffer
        container.scrollBy({
          top: scrollOffset,
          behavior: "smooth",
        });
      }

      // Optional: handle top overflow too
      else if (popupRect.top < containerRect.top) {
        const scrollOffset = containerRect.top - popupRect.top + 10;
        container.scrollBy({
          top: -scrollOffset,
          behavior: "smooth",
        });
      }
    }
  }, [showOptions]);
  const fetchSessions = async () => {
    const {
      data: { session },
      error,
    } = await supabase.auth.getSession();
    if (session) {
      // Fetch parent sessions (where parent_session is null)
      const { data: parentSessions, error: parentError } = await supabase
        .from("chat_session")
        .select("*")
        .eq("type", "notification")
        .eq("user_auth", session.user.id)
        .order("updated_at", { ascending: false });

      if (parentError) {
        console.error("Error fetching parent sessions:", parentError);
      } else {
        setSessions(parentSessions);
        setuserId(session.user.id);
      }
    }
  };
  const activeSessionId = Cookies.get("chat_session_id"); // Get the active session ID from cookies

  useEffect(() => {
    fetchSessions();
  }, [isNotificationSessionChannel]);

  const handleOptionsClick = (sessionId) => {
    setShowOptions(showOptions === sessionId ? null : sessionId);
  };

  const handleRename = (sessionId) => {
    setSessionToRename(sessionId);
    setIsNewSession(false);
    setShowFormPopup(true);
  };

  const handleRemove = (sessionId) => {
    if (sessionId) {
      setSessionToRemove(sessionId);
    } else {
      setSessionToRemove(null);
    }
    setShowRemovePopup(true);
  };
  const handleNewSession = (parentId = null) => {
    setIsNewSession(true);
    setSessionToRename(parentId);
    setShowFormPopup(true);
  };

  const confirmRemove = async (type) => {
    setShowRemovePopup(false);
    setLoader(true);

    if (type) {
      deletSelectedSesion();
    } else {
      try {
        // Get notifications whose session_id is sessionToRemove
        const { data: notifications, error: fetchError } = await supabase
          .from("notifications")
          .select("*")
          .eq("session_id", sessionToRemove);

        if (fetchError) {
          console.error("Error fetching notifications:", fetchError);
          setLoader(false);
          return;
        }

        // Update session_id to null for the fetched notifications
        const { error: updateError } = await supabase
          .from("notifications")
          .update({ session_id: null })
          .in(
            "id",
            notifications.map((notification) => notification.id)
          );

        if (updateError) {
          console.error("Error updating notifications:", updateError);
          setLoader(false);
          return;
        }

        // Proceed with removing the session and chat history
        await removeSessionandChatHistory(sessionToRemove, userId).then(
          async () => {
            setLoader(false);
            if (sessionToRemove === activeSessionId) {
              const { data, error } = await supabase
                .from("chat_session")
                .select("id")
                .eq("user_auth", userId)
                .neq("id", sessionToRemove)
                .order("created_at", { ascending: false })
                .limit(1)
                .single();

              if (data != null && !error) {
                resetSession(data.id);
              } else {
                Cookies.remove("chat_session_id");
                window.location.reload();
              }
            } else {
              fetchSessions();
            }
          }
        );
      } catch (err) {
        console.error("Error during session removal:", err);
        setLoader(false);
      }
    }
  };

  const confirmRename = async (newName, setError) => {
    if (!newName.trim()) {
      setError("Topic name cannot be blank.");
      return;
    }
    const {
      data: { session },
      error,
    } = await supabase.auth.getSession();

    if (session) {
      let createdSession = await createChatSession(
        "notification",
        newName,
        session.user.id,
        sessionToRename,
        null
      ); // Pass parentId if available
      resetSession(sessionToRename); // Call resetSession with the created session ID
      try {
        await fetchSessions(); // Refresh sessions after rename or create
      } catch (err) {
        console.error("Error creating or renaming session:", err);
        setError("An error occurred while creating or renaming the session.");
      }
    }
    setShowFormPopup(false);
    setSessionToRename(null);
    setIsNewSession(false);
  };

  const handleSessionClick = async (sessionId) => {
    const { error } = await supabase
      .from("chat_session")
      .update({ updated_at: new Date() })
      .eq("id", sessionId);

    if (error) {
      console.error("Error updating session timestamp:", error);
    }
    resetSession(sessionId); // Call resetSession with the clicked session's ID
  };

  const handleClosePopup = () => {
    setShowFormPopup(false);
  };
  const handleCheckboxChange = (sessionId) => {
    setCheckedSessions((prev) =>
      prev.includes(sessionId)
        ? prev.filter((id) => id !== sessionId)
        : [...prev, sessionId]
    );
  };
  // Filter sessions based on search query
  const filteredSessions = sessions.filter((session) =>
    session.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleDeleteAll = () => {
    setDeleteAllChecked(!deleteAllChecked);
    if (deleteAllChecked == false) {
      let allSession = [];
      filteredSessions.map((session) => {
        allSession.push(session.id);
      });
      setCheckedSessions(allSession);
    } else {
      setCheckedSessions([]);
    }
  };
  const handleSessionChat = async (id) => {};
  const deletSelectedSesion = async () => {
    if (checkedSessions.length > 0) {
      checkedSessions.forEach(async (sessionToRemove) => {
        try {
          // Get notifications whose session_id is sessionToRemove
          const { data: notifications, error: fetchError } = await supabase
            .from("notifications")
            .select("*")
            .eq("session_id", sessionToRemove);

          if (fetchError) {
            console.error("Error fetching notifications:", fetchError);
            setLoader(false);
            return;
          }

          // Update session_id to null for the fetched notifications
          const { error: updateError } = await supabase
            .from("notifications")
            .update({ session_id: null })
            .in(
              "id",
              notifications.map((notification) => notification.id)
            );

          if (updateError) {
            console.error("Error updating notifications:", updateError);
            setLoader(false);
            return;
          }

          // Proceed with removing the session and chat history
          await removeSessionandChatHistory(sessionToRemove, userId).then(
            async () => {
              setLoader(false);
              if (sessionToRemove === activeSessionId) {
                const { data, error } = await supabase
                  .from("chat_session")
                  .select("id")
                  .eq("user_auth", userId)
                  .neq("id", sessionToRemove)
                  .order("created_at", { ascending: false })
                  .limit(1)
                  .single();

                if (data != null && !error) {
                  resetSession(data.id);
                } else {
                  Cookies.remove("chat_session_id");
                  window.location.reload();
                }
              } else {
                fetchSessions();
              }
              setLoader(false);
            }
          );
        } catch (err) {
          console.error("Error during session removal:", err);
          setLoader(false);
        }
      });
      setCheckedSessions([]);
    }
  };

   const setCombinedRefs = (node) => {
    ulRef.current = node;
    notificationsessionScrollRef.current = node;
  };

   useEffect(() => {
  if (isSidebarVisible) {
    // Reset scroll for all tabs
    if (notificationsessionScrollRef.current) notificationsessionScrollRef.current.scrollTop = 0;
  }
      }, [isSidebarVisible]);
      
  return (
    <>
      {Loader && <LoaderElement />}
      <div ref={mainSessionRef}>
        <div className="container" style={{padding:"4px 12px 4px 24px"}}>
          {/* {filteredSessions.length > 0 && ( */}
          <div className="d-flex gap-2 mb-2">
            <div className="search-input-wrapper flex-grow-1">
              <input
                className="form-control search-input-box"
                type="text"
                placeholder="Search conversations..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              {searchQuery && (
                <i
                  className="bi bi-x search-clear-icon"
                  onClick={() => setSearchQuery("")}
                ></i>
              )}
            </div>
            <button 
              className="deleteButtonNoSession" 
              style={{
                height: '38px',
                width: '38px',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '8px'
              }}
              onClick={() => {setCheckedSessions([]); setActiveSessionDelete(!activeSessionDelete)}}
            >
              <i className="bi bi-trash"></i>
            </button>
          </div>
          {/* )} */}
          {(activeSessionDelete) && (
            <div className="d-flex align-items-center gap-2 mb-2">
              <button className="select-deselected flex-grow-1" onClick={() => { setCheckedSessions(filteredSessions.map(session => session.id)); }}>Select All</button>
              <button className="select-deselected flex-grow-1" onClick={() => { setCheckedSessions([]); }}>Unselect All</button>
            </div>
          )}
          
          {(checkedSessions.length > 0 && activeSessionDelete ) && (
            <div className="d-flex align-items-center mb-2">
              <button className="deleteButton deleteAllSelected w-100" onClick={() => { handleRemove(null);}}>Delete {checkedSessions.length} of {filteredSessions.length}</button>
            </div>
          )}

          {/* {checkedSessions.length > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px 0",
                marginLeft: "1rem",
              }}
            >
              <input
                type="checkbox"
                checked={deleteAllChecked}
                onChange={handleDeleteAll}
                style={{
                  marginRight: "10px",
                  cursor: "pointer",
                }}
              />
              <i
                className="bi bi-trash"
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleRemove(null);
                }}
              >
                {" "}
                Delete {checkedSessions.length} of {filteredSessions.length}
              </i>
            </div>
          )} */}
        </div>
        <ul
          className="sessionBox"
          ref={setCombinedRefs}
        >
          {filteredSessions.length > 0 ? (
            filteredSessions.map((session) => (
              <li
                key={session.id}
                className={
                  session.id === activeSessionId
                    ? "active-session-notification d-flex justify-content-between align-items-center border-0 me-2 mb-2"
                    : "d-flex justify-content-between session-notification-menu align-items-center border-0 me-2 mb-2"
                }
                onClick={() => {
                  handleSessionChat(session.id);
                }}
              >
                <div className="d-flex align-items-center">
                  {(filteredSessions.length > 0 && activeSessionDelete) ? (
                    <input
                      type="checkbox"
                      className="session-checkbox"
                      checked={checkedSessions.includes(session.id)}
                      onChange={() => handleCheckboxChange(session.id)}
                    />
                  ) : null}
                  <Link
                    onClick={() => handleSessionClick(session.id)}
                    className="text-decoration-none notification-session-link"
                  >
                    <b>{session.name}</b>
                  </Link>
                </div>
                <div className="session-menu-wrapper">
                  <i
                    className="bi bi-three-dots-vertical"
                    onClick={() => handleOptionsClick(session.id)}
                  ></i>
                  {showOptions === session.id && (
                    <div
                      className="three-dot-dropdown"
                      ref={optionsRef}
                    >
                      <div
                        className="dropdown-option-hover"
                        onClick={() => handleRename(session.id)}
                      >
                        <i className="bi bi-pencil"></i>
                        Rename
                      </div>
                      <div
                        className="dropdown-option-hover dropdown-option-delete"
                        onClick={() => handleRemove(session.id)}
                      >
                        <i className="bi bi-trash"></i>
                        Remove
                      </div>
                    </div>
                  )}
                </div>
              </li>
            ))
          ) : (
            <div className="text-center">No data found</div>
          )}
        </ul>
        <SessionPopup
          show={showFormPopup}
          handleClose={handleClosePopup}
          title={isNewSession ? "New Topic" : "Rename Topic"}
          button={isNewSession ? "Create" : "Rename"}
          handleConfirm={confirmRename}
          initialValue={
            isNewSession
              ? ""
              : sessions.find((session) => session.id === sessionToRename)
                  ?.name || ""
          }
          backdrop="static" // Prevent closing the modal when clicking outside
        />
        <ConfirmationPopup
          show={showRemovePopup}
          handleClose={() => setShowRemovePopup(false)}
          title="Confirm Removal"
          body="Are you sure you want to remove this session? This action cannot be undone."
          handleConfirm={() =>
            confirmRemove(sessionToRemove == null ? true : false)
          }
          backdrop="static" // Prevent closing the modal when clicking outside
        />
      </div>
    </>
  );
}

export default NotificationSession;
